import { render, staticRenderFns } from "./PriceDisclaimer.vue?vue&type=template&id=3518c332"
import script from "./PriceDisclaimer.vue?vue&type=script&lang=js"
export * from "./PriceDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./PriceDisclaimer.vue?vue&type=style&index=0&id=3518c332&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports